var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"item-box"},_vm._l((_vm.businessList),function(item,i){return _c('li',{key:i,on:{"click":function($event){return _vm.emitToFather(item)}}},[_c('span',{class:_vm.value == item.id ? 'active' : ''},[_vm._v(" "+_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }